import PropTypes from 'prop-types';
import { GAME_TYPES } from '../../../services/utilityFunctions';

const propType = {
  _id: PropTypes.string,
  type: PropTypes.oneOf(GAME_TYPES),
};

export default { propType };
